<template>
  <b-row>
    <b-col
      v-for="option of options"
      :key="option.value"
      cols="12"
      md="auto"
      class="mb-2"
    >
      <button
        v-if="!option.selected"
        type="button"
        class="btn-logic"
        @click="setValue(option)"
      >
        {{ option.text }}
      </button>
      <button
        v-else-if="option.selected"
        type="button"
        class="btn-logic-pressed"
        @click="setValue(option)"
      >
        {{ option.text }}
      </button>
    </b-col>
    <!-- {{options}} -->
  </b-row>
</template>

<script>
import Vue from "vue";
export default {
  name: "BaseImputLogic",
  props: {
    options: Array,
    value: String
  },
  watch: {
    value(newVal) {
      this.options.forEach(opt => {
        Vue.set(opt, 'selected', opt.value === newVal);
      });
    }
  },
  data() {
    return {
      equalWidth: false
    };
  },
  created() {
    this.options.forEach(option => {
      Vue.set(option, "group", "type");
    });
    if (this.value != "")
      this.options.forEach(option => {
        if (option.value == this.value) this.select(option);
      });
  },
  methods: {
    setValue(option) {
      if (this.isEquals(option.value)) {
        this.equalWidth = true;
        this.select(null);
        this.$emit("update:value", null);
        this.$emit("onDataChange");
      } else {
        this.equalWidth = true;
        this.select(option);
        this.$emit("update:value", option.value);
        this.$emit("onDataChange");
      }
    },
    select(option) {
      if (option == null) {
        for (let otherOption of this.options) {
          Vue.set(otherOption, "selected", false);
        }
      } else {
        if (option.group && !option.selected) {
          Vue.set(option, "selected", !option.selected);
          for (let otherOption of this.options) {
            if (
              otherOption.text !== option.text &&
              option.group === otherOption.group
            ) {
              Vue.set(otherOption, "selected", false);
            }
          }
        } else if (!option.group) {
          Vue.set(option, "selected", !option.selected);
        }
      }
      this.$emit("change", this.options);
    },
    isEquals(newValue) {
      if (this.value == null) return false;
      if (this.value == newValue) return true;
      return false;
    }
  },
  watch: {
    value() {
      if (this.value == "") {
        this.options.forEach(option => {
          Vue.set(option, "selected", false);
        });
      }
    }
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .btn-logic,
  .btn-logic-pressed {
    width: 100%; /* Ocupa toda a largura no mobile */
    display: block;
  }
}
</style>
